<template>
  <BaseSection is-wide>
    <template #header>
      <BaseTitle
        tag="h1"
        size="xl"
        is-medium
        data-animation="fadeInTop"
        data-animation-delay="100"
        text="Какие практики используют ведущие российские компании?"
      />
    </template>
    <template #content>
      <div class="section__offset">
        <TheVideos :videos="videos" :delay="300" @play="showModalVideo" />
      </div>
      <hr
        class="app__sep"
        data-animation="fadeIn"
        data-animation-delay="600"
      />
      <BaseText
        size="m"
        tag="div"
        data-animation="fadeInRight"
        data-animation-delay="900"
        v-html="'<p>Команда 77 experts обратилась к HR&#8209;экспертам лучших российских работодателей, чтобы узнать об их опыте решения проблем.</p><p>Каждому было задано по три вопроса в&nbsp;рамках одной ценности:</p>'"
        style="max-width: 26em;"
      />
      <div class="section__gap">
        <BaseSteps :items="steps" :delay="1200" is-triple />
      </div>
    </template>
    <TheVideoModal v-if="video" :video="video" class="app__modal" @click:close="hideModalVideo" />
    <BaseModal v-if="isModalOpen" class="app__modal" @click:close="hideModal">
      <TheReviewForm @next="skip" />
    </BaseModal>
  </BaseSection>
</template>

<script>
import { mapState } from 'vuex';

import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
import BaseSteps from '@/components/BaseSteps.vue';
import TheVideos from '@/components/TheVideos.vue';
import TheVideoModal from '@/components/TheVideoModal.vue';
import TheReviewForm from '@/components/TheReviewForm.vue';
import BaseModal from '@/components/BaseModal.vue';

export default {
  name: 'QuestionsPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseTitle,
    BaseText,
    BaseSteps,
    TheVideos,
    TheVideoModal,
    TheReviewForm,
    BaseModal,
  },
  data() {
    return {
      videoId: null,
      isModalOpen: false,
    };
  },
  staticData: () => ({
    steps: [
      {
        text: 'Какая из перечисленных проблем наиболее ярко отобразилась на вашей работе?',
        attrs: { size: 's' },
      },
      {
        text: 'Были ли введены корректирующие меры?',
        attrs: { size: 's' },
      },
      {
        text: 'Как вы видите решение проблемы в идеале?',
        attrs: { size: 's' },
      },
    ],
    videos: [
      {
        image: 'develop',
        title: 'Норникель',
        text: 'О ценности:<br> «Нерутинный труд и&nbsp;возможность развиваться»',
      },
      {
        image: 'communication',
        title: 'Газпромбанк',
        text: 'О ценности:<br> «Человеческое общение»',
      },
      {
        image: 'balance',
        title: 'Норбит',
        text: 'О ценности:<br> «Баланс между работой и&nbsp;личной жизнью»',
      },
    ],
  }),
  computed: {
    ...mapState(['isReviewSended']),
    video() {
      if (!this.videoId) return null;
      return {
        file: this.videoId,
        autoplay: 600,
      };
    },
  },
  methods: {
    showModalVideo(id) {
      this.videoId = `${id}.mp4`;
    },
    hideModalVideo() {
      this.videoId = '';
    },
    showModal() {
      this.isModalOpen = true;
    },
    hideModal() {
      this.isModalOpen = false;
    },
    goNext() {
      if (this.isReviewSended) {
        this.goToNextSlide();
      } else {
        this.showModal();
      }
    },
    skip() {
      this.hideModal();
      this.$nextTick(this.goToNextSlide);
    },
  },
};
</script>
